module.exports = __webpack_public_path__ + "static/mr-concert-performance-06-67b4bfefaf7ad8ee1ab08518c7d19f93.jpg";